export const getUrl = (input?: string) => {
  if (!input || input?.startsWith("https")) {
    return input;
  }
  return `https://${input}`;
};
